import React, { useState } from "react";
import Select, { TOption } from "../../../Components/Select";
import { IDevice } from "../../devices/types";
import MqttTriggerForm from "./MqttTriggerForm";
import {
  defaultMqttTrigger,
  defaultSunTrigger,
  defaultTimeTrigger,
  TMqttTrigger,
  TSunTrigger,
  TTimeTrigger,
} from "./types";
import SunTriggerForm from "./SunTriggerForm";
import TimeTriggerForm from "./TimeTriggerForm";
import { getDevicesWithValuesOrStates } from "../utils";
import { useTranslation } from "react-i18next";

const defaultTriggers = {
  time: defaultTimeTrigger,
  sun: defaultSunTrigger,
  mqtt: defaultMqttTrigger,
};

type TTriggerType = "time" | "sun" | "mqtt";

export type TTrigger = TTimeTrigger | TSunTrigger | TMqttTrigger;

interface ITriggerFormProps {
  trigger: TTrigger;
  devices: IDevice[];
  onChange: (trigger: TTrigger) => void;
}

const TriggerForm = (props: ITriggerFormProps) => {
  const { trigger, devices, onChange } = props;
  const [initialTrigger, setInitialTrigger] = useState<TTrigger>(trigger);
  const { t } = useTranslation();

  const triggerTypeOptions: TOption<TTriggerType>[] = [
    { value: "time", label: t("Time") },
    { value: "sun", label: t("Sun") },
    { value: "mqtt", label: t("MQTT") },
  ];

  return (
    <>
      <Select
        fullWidth
        label={t("Trigger Type")}
        options={triggerTypeOptions}
        value={initialTrigger.type}
        onChange={(event) => {
          const newTrigger =
            defaultTriggers[event.target.value as TTriggerType];
          setInitialTrigger(newTrigger);
          onChange(newTrigger);
        }}
        data-cy="trigger-select-trigger-type"
      />
      {initialTrigger.type === "time" && (
        <TimeTriggerForm trigger={initialTrigger} onChange={onChange} />
      )}
      {initialTrigger.type === "sun" && (
        <SunTriggerForm trigger={initialTrigger} onChange={onChange} />
      )}
      {initialTrigger.type === "mqtt" && (
        <MqttTriggerForm
          trigger={initialTrigger}
          devices={getDevicesWithValuesOrStates(devices)}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default TriggerForm;
